import React from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import AutoScale from 'react-auto-scale'
import { injectState } from 'freactal'
import { getSlides } from '../../../lib'
import { List } from 'react-virtualized'

import Slide from './Slide'

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-height: 100%;
  overflow-y: auto;
`
const SlideContainer = styled.div`
  display: inline-block;
  background-color: ${({ selected }) => (selected ? 'yellow' : 'initial')};
  padding: 0.25em;
  height: 190px;
  width: 250px;
`

class SlidesList extends React.Component {
  rowRenderer = ({ key, index, style }) => {
    const {
      state: { unit },
      match: { params: { sectionIndex, slideIndex } },
      history,
    } = this.props
    const slides = getSlides(unit)
    const slide = slides[index]
    const joinedSectionIndex = slide.sectionIndex.join('.')
    return (
      <div style={style} key={key}>
        <SlideContainer
          selected={
            joinedSectionIndex === sectionIndex &&
            slide.slideIndex === parseInt(slideIndex, 10)
          }>
          <AutoScale>
            <Slide
              slide={slide}
              useThumbnail
              onClick={() =>
                history.push(
                  `/units/${unit._id}/presentation/${joinedSectionIndex}/${slide.slideIndex}/`,
                )}
            />
          </AutoScale>
        </SlideContainer>
      </div>
    )
  }

  render() {
    const { state: { unit } } = this.props
    const slidesLength = getSlides(unit).length

    return (
      <Container>
        <List
          width={275}
          height={850}
          rowHeight={200}
          rowCount={slidesLength}
          rowRenderer={this.rowRenderer}
        />
      </Container>
    )
  }
}

export default withRouter(injectState(SlidesList))



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/PresentationContent/SlidesList.js